<splash-screen></splash-screen>

<router-outlet
  *ngIf="
    (isAppInitialized$ | async) &&
    !(isLoadingRoute && !(isPagesComponentExisting$ | async))
  "
></router-outlet>

<lipp-toast></lipp-toast>
